import { render, staticRenderFns } from "./nav-app-list.vue?vue&type=template&id=1f6c1506"
import script from "./nav-app-list.vue?vue&type=script&lang=js"
export * from "./nav-app-list.vue?vue&type=script&lang=js"
import style0 from "./nav-app-list.vue?vue&type=style&index=0&id=1f6c1506&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports